import {
  Home,
  PersonOutline,
  Store,
  Stars,
  MonetizationOn,
  ViewColumn,
  ChromeReaderMode,
  Adjust,
  Settings,
  Wifi,
  PhoneOutlined,
  FileCopyOutlined,
} from '@material-ui/icons';

import CalendarTodayOutlinedIcon from '@material-ui/icons/CalendarTodayOutlined';
import { ReactComponent as StoreIconVector } from 'assets/store-Icon-Vector.svg';
import { ReactComponent as Ajuda } from 'assets/ajuda-default.svg';
import { ReactComponent as Config } from 'assets/config-default.svg';
import { ReactComponent as Estoque } from 'assets/estoque-ativo.svg';
import { ReactComponent as Faturas } from 'assets/faturas-default.svg';
import { ReactComponent as Inicio } from 'assets/inicio-default.svg';
import { ReactComponent as Performance } from 'assets/performance-default.svg';
import { ReactComponent as Propostas } from 'assets/propostas-default.svg';
import { ReactComponent as Solucoes } from 'assets/solucoes.svg';
import { ReactComponent as Notebook } from 'assets/notebook.svg';
import { ReactComponent as MobiPhone } from 'assets/mobiphone-icon.svg';
import { ReactComponent as Integracao } from 'assets/integracao-icon.svg';
import { ReactComponent as Vender } from 'assets/payments-icon.svg';
import { ReactComponent as CarMultiple } from 'assets/car-multiple-icon.svg';
import { ReactComponent as Calendar } from 'assets/calendarContact.svg';
import { ReactComponent as Contacts } from 'assets/account-multiple.svg';
import { ReactComponent as Financing } from 'assets/institution-icon-white.svg';
import { ReactComponent as GestaoVeiculos } from 'assets/vehicles-management.svg';
import { ReactComponent as Faturamento } from 'assets/BillingIcon.svg';
import { ReactComponent as MobiOne } from 'assets/mobiOne.svg';
import { ReactComponent as PasseCarrosLogo } from 'assets/passe_carros_logo.svg';
import { ReactComponent as PrimeiraMaoSaga } from 'assets/primeira_mao.svg';
import { ReactComponent as StockIconVector } from 'assets/StockIconVector.svg';
import { ReactComponent as SupportAgentIcon } from 'assets/SupportAgentIcon.svg';
import { ReactComponent as CrmIcon } from 'assets/crm-icon.svg';
import { ReactComponent as PatioControl } from 'assets/car-repair-tow-truck.svg';
import { ReactComponent as MobiAnalyticsIcon } from 'assets/superset-icon.svg';
import { ReactComponent as FeiraoIcon } from 'assets/feirao.svg';
import { ReactComponent as TooMechanicalWarranty } from 'assets/too_mechanical_warranty.svg';
import { ReactComponent as CorporateSalesManagerIcon } from 'assets/corporate-sales-manager-icon.svg';
import { ReactComponent as MrApps } from 'assets/mrApps.svg';

import React from 'react';

const configIcon = {
  feirao: <FeiraoIcon />,
  home: <Home />,
  pessoafisica: <PersonOutline />,
  pessoajuridica: <Store />,
  reception: <SupportAgentIcon />,
  montadora: <Stars />,
  catalogo: <ViewColumn />,
  financeiro: <MonetizationOn />,
  editorial: <ChromeReaderMode />,
  estoqueLoja: <StockIconVector style={{ width: '24px', height: '19px' }} />,
  marketing: <Adjust />,
  settings: <Settings />,
  help: <Ajuda />,
  config: <Config />,
  estoque: <Estoque />,
  estoqueGrupo: <StoreIconVector />,
  corporateSalesManager: <CorporateSalesManagerIcon />,
  faturas: <Faturas />,
  inicio: <Inicio />,
  performance: <Performance />,
  propostas: <Propostas />,
  solucoes: <Solucoes />,
  mobiFi: <Wifi />,
  dealerSite: <Notebook />,
  mobiPhone: <MobiPhone />,
  mobiPhoneGroup: <PhoneOutlined />,
  integracao: <Integracao />,
  resale: <CarMultiple />,
  resaleSelling: <Vender />,
  resaleBuy: <PasseCarrosLogo style={{ width: '24px', height: '24px' }} />,
  calendar: <Calendar />,
  calendarTodayOutlinedIcon: <CalendarTodayOutlinedIcon />,
  contacts: <Contacts />,
  manageDeals: <GestaoVeiculos />,
  Financing: <Financing />,
  Faturamento: <Faturamento />,
  mobiOne: <MobiOne />,
  sagaSite: <PrimeiraMaoSaga style={{ width: '20px', height: '20px' }} />,
  crm: <CrmIcon style={{ width: '24px', height: '24px' }} />,
  patioSystemControl: <PatioControl />,
  mobiAnalyticsIcon: <MobiAnalyticsIcon />,
  billingCenter: <FileCopyOutlined />,
  TooMechanicalWarranty: <TooMechanicalWarranty />,
  MrApps: <MrApps />,
};

export default configIcon;
